import React from 'react';
import { LoadingProvider } from './context/LoadingContext';

const GlobalLoadingProvider = ({ children }) => {
  return <LoadingProvider>{children}</LoadingProvider>;
};

export default GlobalLoadingProvider;
